// Test data for AI Import functionality
// This file contains sample content that can be used to test the AI import feature

export const sampleWebsiteContent = `
BC Science Fair 2025
Annual science fair for students across British Columbia to showcase their scientific projects and innovations.

Organization: Science Fair Foundation BC
Location: Vancouver, BC
Dates: May 10-12, 2025
Application Period: January 15 - April 15, 2025
Eligibility: Students in grades 7-12 in British Columbia
Cost: Free
Type: Competition
Grade Levels: Middle School, High School
Interaction: In-Person
Tags: Science, Research, K-12, Competition
Website: https://example.com/bcsciencefair

---

UBC Quantum Computing Hackathon
A weekend-long hackathon focused on quantum computing applications and challenges.

Organization: UBC Quantum Computing Club
Location: University of British Columbia, Vancouver
Dates: June 20-22, 2025
Application Period: May 1 - June 10, 2025
Eligibility: University students and recent graduates
Cost: Free
Type: Hackathon
Grade Levels: Undergraduate, Graduate
Interaction: In-Person
Tags: Quantum Computing, Programming, University, Hackathon
Website: https://example.com/ubcquantumhackathon

---

BC STEM Innovation Grant
Funding opportunity for innovative STEM projects that benefit the British Columbia community.

Organization: BC Innovation Council
Location: British Columbia
Dates: January 1 - December 31, 2025
Application Period: January 1 - September 30, 2025
Eligibility: BC residents with innovative STEM project ideas
Cost: N/A
Type: Grant
Grade Levels: All Levels
Interaction: Virtual
Tags: Funding, Innovation, Research, Grant
Website: https://example.com/bcinnovationgrant

---

Women in Technology Scholarship
Scholarship for women pursuing careers in technology fields in British Columbia.

Organization: BC Tech Association
Location: British Columbia
Dates: January 1 - July 31, 2025
Application Period: January 1 - May 31, 2025
Eligibility: Women enrolled in technology programs at BC post-secondary institutions
Cost: N/A
Type: Scholarship
Grade Levels: Undergraduate, Graduate
Interaction: Virtual
Tags: Women in Tech, Education, Scholarship, Diversity
Website: https://example.com/womenintechscholarship

---

Vancouver Tech Conference
Annual technology conference featuring industry leaders, workshops, and networking opportunities.

Organization: Vancouver Tech Alliance
Location: Vancouver Convention Centre
Dates: October 15-17, 2025
Application Period: May 1 - September 30, 2025
Eligibility: Open to all
Cost: $299 - $599
Type: Conference
Grade Levels: All Levels
Interaction: In-Person
Tags: Technology, Networking, Professional Development, Conference
Website: https://example.com/vancouvertechconference
`;

export const simpleTestContent = `
Summer Coding Bootcamp 2025
Intensive 8-week coding bootcamp for beginners. Learn web development, Python, and JavaScript.

Organization: Tech Academy BC
Location: Vancouver, BC
Dates: July 1 - August 26, 2025
Application Deadline: June 15, 2025
Eligibility: Adults 18+ with no prior coding experience required
Cost: $2,500 (payment plans available)
Type: Workshop/Programs
Grade Levels: Professional
Interaction: In-Person
Tags: Coding, Web Development, Python, JavaScript, Bootcamp
Website: https://techacademybc.com/bootcamp
`;

export const minimalTestContent = `
Robotics Competition
High school robotics competition. Teams build and program robots to complete challenges.

Organization: BC Robotics Society
Location: Surrey, BC
Dates: March 15, 2025
Cost: $50 per team
Eligibility: High school students
Type: Competition
`;

// Helper function to get random test content
export const getRandomTestContent = (): string => {
  const testContents = [sampleWebsiteContent, simpleTestContent, minimalTestContent];
  return testContents[Math.floor(Math.random() * testContents.length)];
};

// Helper function to get test content by type
export const getTestContent = (type: 'full' | 'simple' | 'minimal'): string => {
  switch (type) {
    case 'full':
      return sampleWebsiteContent;
    case 'simple':
      return simpleTestContent;
    case 'minimal':
      return minimalTestContent;
    default:
      return simpleTestContent;
  }
};
